<template>
  <v-content>
    <v-container>
      <tasks-templates-list
        :title="title"
        :headers="headers"
        :data="data"
        :response="response"
        :loading="loading"
        @reload="loadTemplates"
        @new="newFn"
        @edit="editFn"
        @remove="removeFn"
      />
    </v-container>
    <delete-dialog
      :dialog="deleteDialog"
      :item="templateName"
      @agree="removeHandler"
      v-show="false"
    />
  </v-content>
</template>

<script>
import api from "@/utils/api.js";
import TasksTemplatesList from "@/components/lists/TasksTemplatesList.vue";
import snackbar from "@/utils/snackbar.js";
import DeleteDialog from "@/components/dialogs/DeleteDialog.vue";
export default {
  components: {
    TasksTemplatesList,
    DeleteDialog,
  },
  data: () => ({
    headers: [
      {
        text: "Title",
        align: "left",
        value: "name",
      },
      { text: "", align: "right", value: "action", sortable: false },
    ],
    title: "Checklists",
    data: [],
    sort: "name",
    deleteDialog: false,
    templateName: null,
    template: {},
    boat: null,
    boatName: null,
    loading: true,
    response: null,
  }),
  created() {
    this.setInitialData();
    if (this.$route.query.page || this.$route.query.search) {
      this.loadTemplates(this.$route.query);
    } else {
      this.loadTemplates();
    }
  },
  methods: {
    setInitialData() {
      this.headers = [
        {
          text: this.$t("tasks.tasksTemplates.title"),
          align: "left",
          value: "name",
        },
        { text: "", align: "right", value: "action", sortable: false },
      ];
      this.title = this.$t("tasks.tasksTemplates.checklists");
    },
    loadTemplates(params) {
      if (!params) {
        params = {};
      }
      this.loading = true;
      this.data = [];
      api.getTemplateList(params).then((resp) => {
        this.response = resp.data;
        this.data = resp.data.results.map((element) => {
          return {
            ...element,
            icon: "mdi-calendar-plus",
          };
        });
        this.loading = false;
      });
    },

    editFn(task) {
      this.$router.push({
        name: "tasksTemplatesEdit",
        params: { id: task.uuid },
      });
    },

    removeFn(template) {
      this.templateName = template.checklists[0].name;
      this.template = template;
      this.deleteDialog = true;
    },

    removeHandler(agreed) {
      if (agreed) {
        api.deleteTemplate(this.template.uuid).then((resp) => {
          snackbar.success(
            this.$t("utils.snackbar.success.successfullyDeleted")
          );
          this.loadTemplates(this.$route.query);
        });
      }
      this.deleteDialog = false;
    },

    newFn(task) {
      this.$router.push({
        name: "tasksTemplatesNew",
      });
    },
  },
};
</script>
